exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/modules/_wks-ext.js
// module id = 343
// module chunks = 168707334958949